// utils/adminUtils.ts
import { collection, getDocs, DocumentData } from "firebase/firestore";
import { db } from "../../firebaseConfig";

// Funzione per recuperare i documenti della disponibilità
export const fetchAvailabilityDocuments = async (value: string) => {
  let collectionName = value === "prezzo" ? "dailyPrices" : "availability";
  const querySnapshot = await getDocs(collection(db, collectionName));
  const documents: DocumentData[] = [];
  querySnapshot.forEach((doc) => {
    documents.push({ id: doc.id, ...doc.data() });
  });
  return documents;
};

// Gestione del cambiamento della stanza selezionata
export const handleRadioChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  setSelectedRoom: React.Dispatch<React.SetStateAction<string>>
) => {
  setSelectedRoom(event.target.value);
};


export const handleMinNightsChange = (
  event: React.ChangeEvent<HTMLInputElement>, // Evento dell'input (checkbox)
  selectedRooms: string[], // Array di ID delle camere selezionate
  setSelectedRooms: React.Dispatch<React.SetStateAction<string[]>> // Funzione per aggiornare lo stato
) => {
  const roomId = event.target.value;
  console.log(roomId);
  setSelectedRooms(
    (prevRooms) =>
      prevRooms.includes(roomId)
        ? prevRooms.filter((room) => room !== roomId) // Se già selezionata, la rimuove
        : [...prevRooms, roomId] // Altrimenti la aggiunge
  );
};


// Gestione del cambiamento delle date
export const handleDateChange = (
  date: Date | null,
  isStartDate: boolean,
  bookingDates: { startDate: Date | null; endDate: Date | null },
  setBookingDates: React.Dispatch<
    React.SetStateAction<{ startDate: Date | null; endDate: Date | null }>
  >
) => {
  if (isStartDate) {
    setBookingDates((prevState) => {
      if (date && prevState.endDate && date > prevState.endDate) {
        return { ...prevState, startDate: date, endDate: null };
      }
      return { ...prevState, startDate: date };
    });
  } else {
    setBookingDates((prevState) => {
      if (date && prevState.startDate && date < prevState.startDate) {
        alert("La data di fine non può essere prima della data di inizio.");
        return prevState;
      }
      return { ...prevState, endDate: date };
    });
  }
};
